const relativeFormatter = new Intl.RelativeTimeFormat(undefined, {
  numeric: "always",
  style: "narrow",
});
const exactFormatter = new Intl.DateTimeFormat(undefined, {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  second: "2-digit",
  timeZoneName: "short",
});

export function formatTaskTimestamp(value: string, now: number) {
  // TaskSchema requires Z or an explicit offset; preserve that absolute instant.
  const date = new Date(value);
  const seconds = (date.getTime() - now) / 1000;
  const magnitude = Math.abs(seconds);
  const [unit, size]: ["day" | "hour" | "minute" | "second", number] =
    magnitude >= 86400 ? ["day", 86400] :
    magnitude >= 3600 ? ["hour", 3600] :
    magnitude >= 60 ? ["minute", 60] : ["second", 1];

  return {
    relative: seconds > 0
      ? relativeFormatter.format(Math.trunc(seconds / size), unit)
      : new Intl.NumberFormat(undefined, {
          style: "unit",
          unit,
          unitDisplay: "narrow",
        }).format(Math.floor(magnitude / size)),
    exact: exactFormatter.format(date),
  };
}
